function FixturePosts() {
  return <div className="page">FixturePosts</div>;
}

export default FixturePosts;
